import IncidentForm from "../../../../components/Forms/incidentForm";
import { TabOptions } from "../../../../types/fieldInstance.interface";

const Factors = () => {
  return (
    <div>
      <IncidentForm tabTitle={TabOptions.Factors} />
    </div>
  );
};

export default Factors;
